import Skeleton from '../skeleton/Skeleton';
import { TASK_CATEGORIES } from './staticTasks';
import {
  StyledAIApprovalList,
  StyledCampaignGroup,
  StyledCategoryCard,
  StyledCategoryGrid,
  StyledDraftList,
  StyledPageHeader,
  StyledSkeletonCampaignHeader,
  StyledSkeletonDraftCard,
  StyledTasks,
} from './Tasks.styles';

export const DraftCardSkeleton = () => (
  <StyledSkeletonDraftCard>
    <div className="header">
      <Skeleton width={180} height={12} radius="6px" resp />
      <Skeleton width={88} height={12} radius="6px" resp />
    </div>

    <div className="person-row">
      <Skeleton width={36} height={36} circle resp />
      <div className="lines">
        <Skeleton width={140} height={14} radius="6px" resp />
        <Skeleton width={200} height={12} radius="6px" resp />
      </div>
    </div>

    <div className="message">
      <Skeleton width={220} height={12} radius="6px" resp margin="0 0 10px" />
      <Skeleton width="100%" height={96} radius="8px" resp />
    </div>

    <div className="footer">
      <Skeleton width={220} height={11} radius="6px" resp />
      <div className="footer-actions">
        <Skeleton width={64} height={32} radius="8px" resp />
        <Skeleton width={32} height={32} radius="8px" resp />
        <Skeleton width={108} height={32} radius="8px" resp />
      </div>
    </div>
  </StyledSkeletonDraftCard>
);

const CampaignGroupSkeleton = () => (
  <StyledCampaignGroup>
    <StyledSkeletonCampaignHeader $collapsed>
      <div className="info">
        <div className="title-row">
          <Skeleton width={180} height={15} radius="6px" resp />
          <Skeleton width={72} height={20} radius="12px" resp />
        </div>
        <Skeleton width={140} height={12} radius="6px" resp />
      </div>
      <div className="actions">
        <Skeleton width={44} height={24} radius="12px" resp />
        <Skeleton width={104} height={32} radius="14px" resp />
        <Skeleton width={16} height={16} radius="4px" resp />
      </div>
    </StyledSkeletonCampaignHeader>
  </StyledCampaignGroup>
);

/**
 * The whole page's shape — header, category cards and the campaign list — shown
 * until the pending approvals have arrived. The campaign list arrives
 * collapsed, so its rows are collapsed too; drafts only appear once a campaign
 * is opened, and that has its own skeleton inside the group.
 */
export const TasksSkeleton = ({ groupCount = 3 }) => (
  <StyledTasks aria-busy="true">
    <main className="tasks-main">
      <StyledPageHeader>
        <div>
          <Skeleton width={100} height={28} radius="8px" resp />
          <Skeleton width={420} height={14} radius="6px" margin="10px 0 0" resp />
        </div>
        <Skeleton width={288} height={40} radius="14px" resp />
      </StyledPageHeader>

      <StyledCategoryGrid>
        {TASK_CATEGORIES.map(category => (
          <StyledCategoryCard key={category.id} as="div">
            <Skeleton width={36} height={36} radius="14px" resp />
            <div className="meta">
              <Skeleton width={96} height={14} radius="6px" resp />
              <Skeleton width={56} height={12} radius="6px" margin="6px 0 0" resp />
            </div>
          </StyledCategoryCard>
        ))}
      </StyledCategoryGrid>

      <StyledAIApprovalList>
        {Array.from({ length: groupCount }, (_, index) => (
          <CampaignGroupSkeleton key={index} />
        ))}
      </StyledAIApprovalList>
    </main>
  </StyledTasks>
);

export const LoadMoreDraftsSkeleton = ({ count = 2 }) => (
  <StyledDraftList style={{ borderTop: 'none', paddingTop: 0, background: 'transparent' }}>
    {Array.from({ length: count }, (_, index) => (
      <DraftCardSkeleton key={index} />
    ))}
  </StyledDraftList>
);
